import { FormMode } from '../../controls/common/form-mode';
import { ApplicationFormContext } from './application-form-context';

export class ApplicationDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.applicationContext.mode = value;
    }

    public editedApplicationId: string = null;

    public applicationContext: ApplicationFormContext = new ApplicationFormContext();
}
